var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['j-button', ("is-" + _vm.type), ("is-" + _vm.shape),
    ['large', 'small'].includes(_vm.size) ? ("is-" + _vm.size) : '',
    _vm.loading ? 'is-loading' : '',
    _vm.disabled ? 'is-disabled' : ''],attrs:{"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.icon)?_c('i',{class:("fa fa-" + _vm.icon)}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4afd0535","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/button.vue
// module id = rFuv
// module chunks = 1